import Enum from "../../../enums/Enum";

const ReferralCycleEnum = new Enum({
    INITIAL_REQUEST: {name: "Initial Request"},
    VALIDITY_EXTENSION: {name: "Validity Extension"},
    FIRST_PR: {name: "First PR"},
    SECOND_PR: {name: "Second PR"},
    OTHER: {name: "Other"},
});

export default ReferralCycleEnum;
